<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<h2>Escrows Report</h2>


@if (showSearchUI) {
  <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=false [showDevelopments]=false
    [showShortTermRentals]=true [showRateBuckets]=false [showBedrooms]=false [showSeasons]=false
    [showReservationStatuses]=true [showStartDate]=true [showEndDate]=true [defaultStartDate]="defaultStartDate"
    [defaultEndDate]="defaultEndDate" [defaultShortTermRentalIds]="defaultShortTermRentalIds"
    [defaultReservationStatuses]="defaultReservationStatuses" (doSearchCB)="onSearchSubmit($event)">
  </app-search-template>
}
<br><br>

<ag-grid-angular
  style="width: auto; height: 70vh;"
  class="ag-theme-balham"
  [gridOptions]="gridOptions"
  [rowData]="resRevByDay"
  (gridReady)="onGridReady($event)"
  (firstDataRendered)="onFirstDataRendered($event)"
  (rowGroupOpened)="onRowGroupOpened($event)"
  >
</ag-grid-angular>